import Mutations from '../../odata/mutations';

export default { ...new Mutations('timeSheetDocument'), ...new Mutations('timeSheetDocuments') };
